export function RevisionIcon({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.875 6.75C4.57663 6.75 4.29048 6.86853 4.0795 7.0795C3.86853 7.29048 3.75 7.57663 3.75 7.875V19.125C3.75 19.4234 3.86853 19.7095 4.0795 19.9205C4.29048 20.1315 4.57663 20.25 4.875 20.25H16.125C16.2727 20.25 16.419 20.2209 16.5555 20.1644C16.692 20.1078 16.816 20.025 16.9205 19.9205C17.025 19.816 17.1078 19.692 17.1644 19.5555C17.2209 19.419 17.25 19.2727 17.25 19.125V10.5C17.25 10.0858 17.5858 9.75 18 9.75C18.4142 9.75 18.75 10.0858 18.75 10.5V19.125C18.75 19.4697 18.6821 19.8111 18.5502 20.1295C18.4183 20.448 18.2249 20.7374 17.9812 20.9812C17.7374 21.2249 17.448 21.4183 17.1295 21.5502C16.8111 21.6821 16.4697 21.75 16.125 21.75H4.875C4.17881 21.75 3.51113 21.4734 3.01884 20.9812C2.52656 20.4889 2.25 19.8212 2.25 19.125V7.875C2.25 7.17881 2.52656 6.51113 3.01884 6.01884C3.51113 5.52656 4.17881 5.25 4.875 5.25H12.7256C13.1398 5.25 13.4756 5.58579 13.4756 6C13.4756 6.41421 13.1398 6.75 12.7256 6.75H4.875Z"
        fill="white"
      />
      <path
        d="M21.5596 2.49611C21.4911 2.42085 21.4081 2.36025 21.3155 2.31799C21.223 2.27573 21.1228 2.25267 21.021 2.25022C20.9193 2.24777 20.8181 2.26596 20.7236 2.30371C20.6291 2.34147 20.5433 2.39798 20.4712 2.46986L19.8914 3.04689C19.8211 3.11721 19.7816 3.21255 19.7816 3.31197C19.7816 3.41138 19.8211 3.50673 19.8914 3.57704L20.4229 4.10767C20.4578 4.14268 20.4992 4.17046 20.5448 4.18941C20.5904 4.20837 20.6393 4.21812 20.6887 4.21812C20.7381 4.21812 20.787 4.20837 20.8326 4.18941C20.8782 4.17046 20.9196 4.14268 20.9545 4.10767L21.5198 3.54517C21.8057 3.2597 21.8325 2.7947 21.5596 2.49611Z"
        fill="white"
      />
      <path
        d="M18.7191 4.21873L10.2572 12.6656C10.2059 12.7167 10.1686 12.7801 10.149 12.8498L9.75756 14.0156C9.74818 14.0472 9.74752 14.0808 9.75564 14.1128C9.76375 14.1448 9.78035 14.174 9.80368 14.1973C9.82701 14.2206 9.85621 14.2372 9.88818 14.2453C9.92016 14.2535 9.95374 14.2528 9.98537 14.2434L11.1502 13.852C11.2199 13.8323 11.2833 13.795 11.3344 13.7437L19.7813 5.28091C19.8595 5.20193 19.9033 5.09531 19.9033 4.98419C19.9033 4.87308 19.8595 4.76646 19.7813 4.68748L19.3149 4.21873C19.2358 4.13987 19.1287 4.09558 19.017 4.09558C18.9053 4.09558 18.7982 4.13987 18.7191 4.21873Z"
        fill="white"
      />
    </svg>
  );
}

export default RevisionIcon;
